// extracted by mini-css-extract-plugin
module.exports = {"root":"WhyWe_root__k4_sd","root_items":"WhyWe_root_items__E24KO","root_items_item":"WhyWe_root_items_item__naAui"};